// src/components/auth/AdminRedirectComponent.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminRedirectComponent = ({ children }) => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin()) {
      navigate('/sites', { replace: true });
    }
  }, [isAdmin, navigate]);

  // If user is Admin, don't render children as they will be redirected
  if (isAdmin()) {
    return null;
  }

  // For SuperAdmin and Driver, render the children (Dashboard/Companies)
  return children;
};

export default AdminRedirectComponent;